import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import AISolutions from "../pages/services/ai-solutions/page";
import WebApplications from "../pages/services/web-applications/page";
import WindowsApplications from "../pages/services/windows-applications/page";
import MobileApplications from "../pages/services/mobile-applications/page";
import Products from "../pages/products/page";
import Portfolio from "../pages/portfolio/page";
import Industries from "../pages/industries/page";
import Clients from "../pages/clients/page";
import Contact from "../pages/contact/page";
import RequestDeleteAccount from "../pages/request-delete-account/page";
import PrivacyPolicy from "../pages/privacy-policy/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/services/ai-solutions", element: <AISolutions /> },
  { path: "/services/web-applications", element: <WebApplications /> },
  { path: "/services/windows-applications", element: <WindowsApplications /> },
  { path: "/services/mobile-applications", element: <MobileApplications /> },
  { path: "/products", element: <Products /> },
  { path: "/portfolio", element: <Portfolio /> },
  { path: "/industries", element: <Industries /> },
  { path: "/clients", element: <Clients /> },
  { path: "/contact", element: <Contact /> },
  { path: "/request-delete-account", element: <RequestDeleteAccount /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
